import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@material-ui/core';

const SaveFilterModal = ({ open, onClose, onSave, editingFilter }) => {
  const [filterName, setFilterName] = useState('');
  const [filterDescription, setFilterDescription] = useState('');

  useEffect(() => {
    if (open) {
      setFilterName(editingFilter ? editingFilter.filterName : '');
      setFilterDescription(editingFilter ? editingFilter.filterDescription || '' : '');
    }
  }, [open, editingFilter]);

  const handleSave = () => {
    if (!filterName.trim()) return;
    onSave(filterName.trim(), filterDescription.trim());
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{editingFilter ? 'Save/Edit Current Filter' : 'Save Current Filter'}</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        {editingFilter && (
          <div style={{ color: '#d32f2f', fontSize: 13, marginBottom: 12 }}>
            Warning: saving will overwrite the existing filter name and description.
          </div>
        )}
        <TextField
          label="Filter Name"
          value={filterName}
          onChange={e => setFilterName(e.target.value)}
          fullWidth
          margin="normal"
          variant="outlined"
          autoFocus
        />
        <TextField
          label="Filter Description"
          value={filterDescription}
          onChange={e => setFilterDescription(e.target.value)}
          fullWidth
          margin="normal"
          variant="outlined"
        />
      </DialogContent>
      <DialogActions style={{ padding: '12px 24px' }}>
        <Button onClick={onClose} style={{ color: '#d32f2f' }}>Cancel</Button>
        <Button
          onClick={handleSave}
          disabled={!filterName.trim()}
          variant="contained"
          style={{ backgroundColor: '#315382', color: '#fff' }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveFilterModal;
